//#region Styles
import { Content } from "../../../../styles";
//#endregion
//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
import TableListItem from "../TableListItem/TableListItem";
//#endregion
//#region Icons
import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
import TrashIcon from "icons/TrashIcon";
import { GET_DIALOG_DELETE_PROPS, SAVE_TYPE } from "../../../Dialogs/constants";
//#endregion

const HEADERS_TABLE_LIST = [
    {
        title: "Día",
        icon: <CalendarIcon/>
    },
        {
        title: "Desde",
        icon: <TimerIcon/>
    },
    {
        title: "Hasta",
        icon: <TimerIcon/>
    },
    {
        title: "Eliminar",
        icon: <TrashIcon color="var(--dark-2)"/>
    }
];

const ScheduleRecords = ({
    schedules,
    openDialogConfirmDelete,
    deleteSchedule
}) => {
    const deleteItem = schedule => {
        openDialogConfirmDelete({
            props: GET_DIALOG_DELETE_PROPS[SAVE_TYPE.SCHEDULE](schedule.dayName),
            deleteAction: () => deleteSchedule(schedule)
        });
    }
    return (
        <Content>
            <CustomTableList
                headers={HEADERS_TABLE_LIST}
                variant="secondary"
                scrollColor="secondary"
                minWidth="400px">
                {schedules.map(schedule => (
                    <TableListItem
                        key={schedule.id} 
                        {...schedule}
                        deleteItem={deleteItem}/>
                ))}
            </CustomTableList>
        </Content>
    );
}

export default ScheduleRecords;